<template>
  <div class="product">
    <div class="iconList">
      <img v-for="item in iconList"  :src="require(`../assets/images/porducts/${item}.png`)" :key="item" />
    </div>
    <div class="current-content">
      <el-carousel height="500px" indicator-position="outside">
        <el-carousel-item v-for="item in currentImgList" :key="item">
          <img :src="require(`../assets/images/porducts/${item}.png`)" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="slider">
      <div v-for="item in classItems" :key="item.id" class="item" @click="handleclick(item)">
        <img :src="require(`../assets/images/porducts/${item.url}.png`)" alt="">
        <div :class="`line ${item.checked ? 'checked' : ''}`"></div>
        <p>{{ item.name }}</p>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      classItems: [
        {id: 1, name: 'COCONUT', checked: true, url: 'class1', imgList: ['pro1', 'pro2', 'pro3', 'pro4']},
        {id: 2, name: 'SODA WATER', checked: false, url: 'class2', imgList: ['pro5']},
        {id: 3, name: 'COFFEE', checked: false, url: 'class3', imgList: ['pro6']},
        {id: 4, name: 'LIFE', checked: false, url: 'class4', imgList: ['pro7', 'pro8', 'pro9',]},
        // {id: 5, name: 'CHANEG', checked: false, url: 'class5', imgList: ['pro10', 'pro11', 'pro12',]},
        {id: 6, name: 'ERAWAN', checked: false, url: 'class6', imgList: ['pro13', 'pro14', 'pro15',]},
      ],
      currentImgList: ['pro1', 'pro2', 'pro3', 'pro4'],
      iconList: ['icon1', 'icon2', 'icon3', 'icon4', 'icon6']
    };
  },
  methods: {
    handleclick(item) {
      if(item.checked) {
        return
      }
      this.classItems.map(element => {
        element.checked = false
      });
      item.checked = true
      this.currentImgList = item.imgList
    }
  },
};
</script>

<style lang="scss" scoped>
.product {
  .iconList{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
  }
  .slider{
    display: flex;
    flex-direction: row;
    width: 1300px;
    margin-left: 70px;
    margin-bottom: 50px;
    .item{
      display: flex;
      flex-direction: column;
      height: 180px;
      width: 325px;
      img{
        height: 140px;
        width: 180px;
        margin: auto;
      }
      .line{
        width: 100%;
        border-bottom: 8px solid #D8D8D8;
      }
      .checked{
        border-color: #04348D;
      }
      p{
        text-align: center;
        color: #000000;
        font-size: 16px;
        font-weight: normal;
      }
    }
  }
}

</style>